import { Box, Button, InputBase, Modal, Typography, Input, IconButton, Tooltip, MenuItem, getListSubheaderUtilityClass, Stack, TextField, Menu, Skeleton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updateSearchOrders, updatesearchProduct } from "../../Redux/page";
import SearchIcon from '@mui/icons-material/Search';
import { useEffect, useState, useMemo } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Toast } from 'primereact/toast';
import { useRef } from "react";
import { OrderListTable } from "../../sub_components/orders_table";
import CustomAxios from "../../utils/CustomAxios";
import CustomAxiosDP from "../../utils/CustomAxiosDP";
import { updateDeliveryPartners, updateFoodfixCutoffTime, updateLoading, updateNewDeliveryPartners, updateOrderDetails, updateOrderModel, updateOrders, updatePartnerAssignModal, updateSelectedDate, updateUpdatedDate, updatefilteredOrders, updateselectedDeliveryPartner, updateSelectedStalls, updateShowStallFilter, updateSelectedCategories, updateSelectedSlotType, updateSelectedSlotTime } from "../../Redux/orders";
import { OrderProductsTable } from "../../sub_components/ordered_products_table";
import { format, subDays, addDays } from 'date-fns';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DownloadIcon from '@mui/icons-material/Download';
import '../../App.css';
import { OrderModal, OrderModalDelivery, useDateformate, useFetchOrders, useGetOrders } from "../globalFunctions";
import { json, useNavigate } from "react-router-dom";
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";

import { updateKioskProduct } from "../../Redux/products";
import KioskOrderManagement from "../kiosk_order_placement";

// Dropdown component for bulk actions
function BulkActionsDropdown({ loading, disabled, counts, onAccept, onOutForDelivery, onDelivered }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Button 
                variant="contained"
                sx={{ 
                    textTransform: "none", 
                    backgroundColor: "#00B3A4",
                    fontSize: { xs: "12px", sm: "14px" },
                    padding: { xs: "6px 12px", sm: "8px 16px" },
                    '&:hover': { backgroundColor: "#00a396" }
                }}
                onClick={handleClick}
                disabled={disabled || loading}
            >
                {loading ? "Processing..." : "Bulk Actions"}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem
                    disabled={counts.pendingCount === 0 || loading}
                    onClick={() => { handleClose(); onAccept(); }}
                >
                    Accept Orders ({counts.pendingCount})
                </MenuItem>
                <MenuItem
                    disabled={counts.outForDeliveryCount === 0 || loading}
                    onClick={() => { handleClose(); onOutForDelivery(); }}
                >
                    Move to Out for Delivery ({counts.outForDeliveryCount})
                </MenuItem>
                <MenuItem
                    disabled={counts.deliverableCount === 0 || loading}
                    onClick={() => { handleClose(); onDelivered(); }}
                >
                    Move to Delivered ({counts.deliverableCount})
                </MenuItem>
            </Menu>
        </>
    );
}
export function OrederManagement() {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const toast = useRef(null);
    const orders = useSelector((state) => state.orders.orders) || [];
    const filteredOrders = useSelector((state) => state.orders.filteredOrders) || [];
    const ordersLoading = useSelector((state) => state.orders.loading);
    const orderModal = useSelector(state => state.orders.orderModal);
    const deliveryPartnerModal = useSelector(state => state.orders.partnerAssignModal);
    const orderedProducts = useSelector(state => state.orders.orderDetails);
    const partners = useSelector(state => state.orders.deliveryPartners);
    const [orderDetails, setOrdersDetails] = useState({})
    const [deliveryPartners, setDeliveryPartners] = useState([])
    const [delivery_data, setDeliveryData] = useState([]);
    const delivery_user = useSelector((state) => state.deliveryUser.delivery);
    const selectedDeliveryPartner = useSelector(state => state.orders.selectedDeliveryPartner);
    const [selectedDate, setSelectedDate] = useState([new Date(), new Date()])
    const updatedDate = useSelector(state => state.orders.updatedDate);
    const today = dayjs()
    const deliveryMode = 1
    const GetOrders = useGetOrders()
    const fetchOrders = useFetchOrders()
    const formatDate = useDateformate()
    const [loading, setLoading] = useState(false);
    const [gstDownloading, setGstDownloading] = useState(false);
    const user_role = localStorage.getItem('role');
    
    // Stall filtering for FoodFix (Franchise 2) - using Redux
    const [stalls, setStalls] = useState([]);
    const selectedStalls = useSelector((state) => state.orders.selectedStalls);
    const showStallFilter = useSelector((state) => state.orders.showStallFilter);
    const hub_ID = useSelector((state) => state.user.selected_hub);
    const foodfixCutoffTime = useSelector((state) => state.orders.foodfixCutoffTime);
     // Category filtering for FoodFix - extract unique categories from current orders
    const selectedCategories = useSelector((state) => state.orders.selectedCategories);
    const selectedSlotType = useSelector((state) => state.orders.selectedSlotType);
    const selectedSlotTime = useSelector((state) => state.orders.selectedSlotTime);
    
     // Use useMemo to compute unique categories from orders' item_category
    const categories = useMemo(() => {
        const categorySet = new Set();
        const orderList = filteredOrders || [];
         
        orderList.forEach(order => {
             if (order.cart_items && Array.isArray(order.cart_items)) {
                 order.cart_items.forEach(cartItem => {
                     if (cartItem.product_details && Array.isArray(cartItem.product_details)) {
                         cartItem.product_details.forEach(product => {
                             if (product.item_category) {
                                 categorySet.add(product.item_category);
                             }
                         });
                     }
                 });
             }
        });
         
         // Convert Set to array of objects with id and category_name for MultiSelect
         return Array.from(categorySet).map((categoryName) => ({
             id: categoryName, // Use category name as id since we don't have category IDs
             category_name: categoryName
         }));
    }, [filteredOrders]);
    
    // Extract unique slot types and time ranges from orders
    const slotTypes = useMemo(() => {
        const typeSet = new Set();
        const orderList = filteredOrders || [];
        
        orderList.forEach(order => {
            if (order.delivery_slot && order.delivery_slot.slot_type) {
                typeSet.add(order.delivery_slot.slot_type);
            }
        });
        
        const types = Array.from(typeSet).map(type => ({
            label: type === 'pickup' ? 'Self Pickup' : 'Delivery',
            value: type
        }));
        
        // Add "All" option at the beginning
        return [{ label: 'All', value: null }, ...types];
    }, [filteredOrders]);
    
    // Extract unique time ranges based on selected slot type
    const slotTimes = useMemo(() => {
        const timeMap = new Map();
        const orderList = filteredOrders || [];
        
        orderList.forEach(order => {
            if (order.delivery_slot && order.delivery_slot.time_range) {
                const slotType = order.delivery_slot.slot_type || 'delivery';
                
                // If a slot type is selected, only include times for that type
                if (selectedSlotType && slotType !== selectedSlotType) {
                    return;
                }
                
                const timeRange = order.delivery_slot.time_range;
                if (!timeMap.has(timeRange)) {
                    timeMap.set(timeRange, {
                        label: timeRange,
                        value: timeRange
                    });
                }
            }
        });
        
        const times = Array.from(timeMap.values()).sort((a, b) => {
            return a.label.localeCompare(b.label);
        });
        
        // Add "All Slots" option at the beginning
        return [{ label: 'All Slots', value: null }, ...times];
    }, [filteredOrders, selectedSlotType]);
    
    // Determine if current selection is Foodfix via franchise id from localStorage
    const isFoodfix = (() => {
        const stored = localStorage.getItem('selected_franchise_id');
        const id = stored ? parseInt(stored, 10) : null;
        return id === 2;
    })();

    const orderFetchStartTime = useMemo(() => {
        const formatTime = (time) => {
            const [hour, minute] = time.split(':').map((value) => parseInt(value, 10));
            return dayjs().hour(hour || 0).minute(minute || 0).second(0).format('hh:mm A');
        };

        if (user_role === 'cashier' || user_role === 'user') {
            return formatTime('11:00');
        }

        if (isFoodfix) {
            // console.log("foodfixCutoffTime ---------------->>>>>>>>>>", foodfixCutoffTime);
            
            if (foodfixCutoffTime) {
                return `${formatTime(foodfixCutoffTime)} (previous day)`;
            }
            return `${formatTime('17:30')} (previous day)`;
        }

        return formatTime('00:00');
    }, [user_role, isFoodfix, foodfixCutoffTime]);
    
    // Check if user can manage orders (create, edit, delete)
    const canManageOrders = ['super_admin', 'admin', 'supervisor', 'cashier', 'user','merchant'].includes(user_role);
    const isCashier = user_role === 'cashier' || user_role === 'user';

    useEffect(() => {
        setOrdersDetails(orderedProducts)
    }, [orderedProducts])

    // Function to fetch stalls for FoodFix (Franchise 2)
    const fetchStallsForFranchise = async (franchiseId) => {
        try {
            const response = await CustomAxios.get(`stalls/franchise/?franchise_id=${franchiseId}`);
            setStalls(response.data || []);
            // console.log('🍽️ OrderManagement: Fetched stalls:', response.data);
        } catch (error) {
            console.error("Error fetching stalls:", error);
            setStalls([]);
        }
    };

    // Function to get franchise ID from localStorage (set by header when hub is selected)
    const getFranchiseIdFromStorage = () => {
        const storedFranchiseId = localStorage.getItem('selected_franchise_id');
        if (storedFranchiseId) {
            const franchiseId = parseInt(storedFranchiseId, 10);
            // console.log('🍽️ OrderManagement: Got franchise ID from localStorage:', franchiseId);
            return franchiseId;
        }
        return null;
    };

    // Function to detect franchise from orders or localStorage
    const detectFranchiseFromOrders = () => {
        // First check localStorage for franchise ID (set by header)
        const storedFranchiseId = getFranchiseIdFromStorage();
        if (storedFranchiseId) {
            return storedFranchiseId;
        }
        
        // Fallback: check if any order has stall_id (indicates FoodFix franchise)
        if (orders && orders.length > 0) {
            const hasStallOrders = orders.some(order => order.stall_id);
            if (hasStallOrders) {
                // console.log('🍽️ OrderManagement: Detected FoodFix franchise from orders with stall_id');
                return 2; // FoodFix
            }
        }
        
        return null;
    };

    // Effect to check franchise ID immediately on component mount
    useEffect(() => {
        const franchiseId = getFranchiseIdFromStorage();
        // console.log('🍽️ OrderManagement: Initial franchise check:', franchiseId);
        // console.log('🍽️ OrderManagement: localStorage selected_franchise_id:', localStorage.getItem('selected_franchise_id'));
        // console.log('🍽️ OrderManagement: localStorage selected_hub:', localStorage.getItem('selected_hub'));
        
        if (franchiseId === 2) {
            // console.log('🍽️ OrderManagement: FoodFix franchise detected from localStorage, showing stall filter');
            dispatch(updateShowStallFilter(true));
            fetchStallsForFranchise(franchiseId);
        } else {
            // console.log('🍽️ OrderManagement: Non-FoodFix franchise or no franchise detected, hiding stall filter');
            dispatch(updateShowStallFilter(false));
            setStalls([]);
            dispatch(updateSelectedStalls([]));
            dispatch(updateSelectedCategories([]));
        }
    }, []); // Run only once on mount

    // Effect to fetch stalls when franchise is detected as 2 (fallback for when orders are loaded without API call)
    useEffect(() => {
        const franchiseId = detectFranchiseFromOrders();
        // console.log('🍽️ OrderManagement: Detected franchise:', franchiseId, 'from orders:', orders?.length);
        
        if (franchiseId === 2) {
            dispatch(updateShowStallFilter(true));
            fetchStallsForFranchise(franchiseId);
        }
        // Note: We don't hide the stall filter here as it might be set by the API response
    }, [orders]);

    // React to hub selection changes from header (via Redux). Toggle stall filter by franchise id in localStorage
    useEffect(() => {
        // hub_ID may be an array [id] or a single value depending on earlier code
        if (hub_ID !== undefined) {
            const storedFranchiseId = localStorage.getItem('selected_franchise_id');
            const franchiseId = storedFranchiseId ? parseInt(storedFranchiseId, 10) : null;
            if (franchiseId === 2) {
                dispatch(updateShowStallFilter(true));
                fetchStallsForFranchise(2);
            } else {
                dispatch(updateShowStallFilter(false));
                setStalls([]);
                dispatch(updateSelectedStalls([]));
                dispatch(updateSelectedCategories([]));
            }
        }
    }, [hub_ID]);

    // Function to filter orders by selected slot type and time
    const filterOrdersBySlot = (ordersList) => {
        let filtered = ordersList;
        
        // Filter by slot type
        if (selectedSlotType) {
            filtered = filtered.filter(order => {
                if (!order.delivery_slot || !order.delivery_slot.slot_type) {
                    return false;
                }
                return order.delivery_slot.slot_type === selectedSlotType;
            });
        }
        
        // Filter by slot time
        if (selectedSlotTime) {
            filtered = filtered.filter(order => {
                if (!order.delivery_slot || !order.delivery_slot.time_range) {
                    return false;
                }
                return order.delivery_slot.time_range === selectedSlotTime;
            });
        }
        
        return filtered;
    };
    
    // Function to filter orders by selected stalls
    const filterOrdersByStalls = (ordersList) => {
        console.log('🍽️ OrderLists: Filtering orders by stalls:', {
            selectedStalls: selectedStalls.map(s => typeof s === 'object' ? { id: s.id, name: s.stall_name } : { id: s, name: 'Unknown' }),
            ordersCount: ordersList.length,
            showStallFilter
        });
        
        if (selectedStalls.length === 0) {
            // console.log('🍽️ OrderLists: No stalls selected, returning all orders');
            return ordersList;
        }
        
        const filtered = ordersList.filter(order => {
            // Try different possible field names for stall ID
            const orderStallId = order.stall_id ;
            
            // Handle both stall objects and stall IDs in selectedStalls
            const matches = selectedStalls.some(stall => {
                // If stall is an object, use stall.id, otherwise use stall directly (if it's just an ID)
                const selectedStallId = typeof stall === 'object' ? stall.id : stall;
                const match = selectedStallId === orderStallId;
                // console.log(`🍽️ OrderLists: Order ${order.id} (stall_id: ${orderStallId}) vs Selected Stall ${selectedStallId} matches:`, match);
                return match;
            });
            return matches;
        });
        
        // console.log('🍽️ OrderLists: Filtered orders result:', filtered.length, 'out of', ordersList.length);
        return filtered;
    };

    // Function to handle bulk order acceptance for selected stalls
    const handleBulkAcceptOrders = async () => {
        console.log('🍽️ Bulk Accept: Starting with', {
            selectedStalls: selectedStalls.length,
            totalOrders: orders.length,
            showStallFilter
        });
        
        if (selectedStalls.length === 0) {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please select at least one stall' });
            return;
        }

        const filteredOrders = filterOrdersByStalls(orderList);
        console.log('🍽️ Bulk Accept: After filtering by stalls:', {
            filteredCount: filteredOrders.length,
            orders: filteredOrders.map(o => ({ id: o.id, status: o.status, stall_id: o.stall_id }))
        });
        
        const pendingOrders = filteredOrders.filter(order => order.status === 'pending');
        console.log('🍽️ Bulk Accept: Pending orders:', {
            pendingCount: pendingOrders.length,
            orders: pendingOrders.map(o => ({ id: o.id, status: o.status, stall_id: o.stall_id }))
        });
        
        if (pendingOrders.length === 0) {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No pending orders found for selected stalls' });
            return;
        }

        try {
            setLoading(true);
            const orderIds = pendingOrders.map(order => order.id);
            
            // Call bulk accept API
            const response = await CustomAxios.post('orders/bulk_order_status_change/', {
                order_ids: orderIds,
                stall_ids: selectedStalls,
                status:'accepted'
            });

            if (response.data.success) {
                toast.current?.show({ severity: 'success', summary: 'Success', detail: `Successfully accepted ${orderIds.length} orders for selected stalls` });
                // Refresh orders
                fetchOrders(selectedDate[0], selectedDate[1]);
            } else {
                toast.current?.show({ severity: 'error', summary: 'Error', detail: response.data.message || "Failed to accept orders" });
            }
        } catch (error) {
            console.error("Error accepting orders:", error);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to accept orders' });
        } finally {
            setLoading(false);
        }
    };
    
    // Generic bulk status update using the same bulk endpoint with status
    const bulkUpdateOrdersStatus = async (orderIds, status) => {
        return CustomAxios.post('orders/bulk_order_status_change/', {
            order_ids: orderIds,
            status,
            stall_ids: selectedStalls
        });
    };
    const orderList = useSelector((state) => state.orders.filteredOrders);

    // Bulk mark as Out for Delivery (order_picked_up)
    const handleBulkOutForDeliveryOrders = async () => {
        console.log('🍽️ Bulk OutForDelivery: Starting');
        if (selectedStalls.length === 0) {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please select at least one stall' });
            return;
        }

        const filtered = filterOrdersByStalls(orderList);
        // Eligible: accepted or delivery_partner_assigned move to order_picked_up
        const eligible = filtered.filter(o => o.status == 'accepted' );
        if (eligible.length === 0) {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No eligible orders for Out for Delivery' });
            return;
        }
        try {
            setLoading(true);
            const orderIds = eligible.map(o => o.id);
            await bulkUpdateOrdersStatus(orderIds, 'ready_for_pickup');
            toast.current?.show({ severity: 'success', summary: 'Success', detail: `Marked ${eligible.length} orders as Out for Delivery` });
            fetchOrders(selectedDate[0], selectedDate[1]);
        } catch (error) {
            console.error('Bulk OutForDelivery error', error);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to update orders' });
        } finally {
            setLoading(false);
        }
    };

    // Bulk mark as Delivered
    const handleBulkDeliveredOrders = async () => {
        console.log('🍽️ Bulk Delivered: Starting');
        if (selectedStalls.length === 0) {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please select at least one stall' });
            return;
        }

        const filtered = filterOrdersByStalls(orderList);
        // Eligible: order_picked_up or picked move to delivered
        const eligible = filtered.filter(o =>  o.status === 'delivery_partner_assigned');
        if (eligible.length === 0) {
            toast.current?.show({ severity: 'info', summary: 'Action Needed', detail: 'Please Assign delivery partner to continue' });
            return;
        }
        try {
            setLoading(true);
            const orderIds = eligible.map(o => o.id);
            await bulkUpdateOrdersStatus(orderIds, 'delivered');
            toast.current?.show({ severity: 'success', summary: 'Success', detail: `Marked ${eligible.length} orders as Delivered` });
            fetchOrders(selectedDate[0], selectedDate[1]);
        } catch (error) {
            console.error('Bulk Delivered error', error);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to update orders' });
        } finally {
            setLoading(false);
        }
    };

    const getDeliveryDetails = async () => {
        try {
            if (delivery_user && delivery_user.length > 0) {
                // Use existing data from Redux
                const Delivery_filter = delivery_user.filter(
                    (data) => data.KYCstatus === "approved" && data.Userstatus === "active"
                );
                setDeliveryData(Delivery_filter);
            } else {
                // Fetch data from API
                const response = await CustomAxiosDP.get(`user-details/`);
                const Delivery_filter = response.data.filter(
                    (data) => data.KYCstatus === "approved" && data.Userstatus === "active"
                );
                setDeliveryData(Delivery_filter);
            }
        } catch (err) {
        }
    };

    const partners_data = partners.filter(partner =>
        delivery_data.some(data => {
            const mobilenoMatch = String(data.mobileno).trim() === String(partner.mobileno).trim();
            return mobilenoMatch;
        })
    );

    const totalPartner = () => {
        partners_data.length > 0 && dispatch(updateNewDeliveryPartners(partners_data))
    }

    useEffect(() => {
        // setDeliveryPartners(partners_data);
        totalPartner()
    }, [partners]);



    useEffect(() => {
        dispatch(updateNewDeliveryPartners(partners_data))

    }, [])



    // useEffect(()=>{
    //     fetchOrders(today)
    // }, [])

    const getUsers = async () => {
        const users = CustomAxiosDP.get(`user-details/`, {
        }).then(res => {
            // let deliveryPartners = res.data.users.filter((user)=>{
            //     return user.role ==='delivery'
            // })
            dispatch(updateDeliveryPartners(res.data))
            dispatch(updateNewDeliveryPartners(partners_data))
        })

    }

    useEffect(() => {
        getUsers()
        getDeliveryDetails();
    }, [])

    const handleCloseOrderModal = () => {
        dispatch(updateOrderModel(false))
        dispatch(updateOrderDetails({}))
        dispatch(updateselectedDeliveryPartner(""))
    };
    const handleClosedeliveryPartnerModal = () => {
        dispatch(updateselectedDeliveryPartner(""))
        dispatch(updatePartnerAssignModal(false))
    };

    const delivery_update = async (id, partner) => {
        const delivery_partner = deliveryPartners.find((part) => part.id == partner)
        const response = await CustomAxiosDP.post('delivery_create/', { mobileno: delivery_partner.mobileno, delivery_mode: deliveryMode, delivery_status: "Pending", user_checkout_id: id }).then((response) => {
        })
    }


    // const handleDateChange = (newDate) => {
    //     setSelectedDate(newDate);
    //     dispatch(updateSelectedDate(newDate))
    //     fetchOrders(newDate);
    //   };

    //   const handlePreviousDay = () => {
    //     const newDate = selectedDate.subtract(1, 'day');
    //       setSelectedDate(newDate);
    //       dispatch(updateSelectedDate(newDate))
    //     fetchOrders(newDate);
    //   };

    //   const handleNextDay = () => {
    //     const newDate = selectedDate.add(1, 'day');
    //       setSelectedDate(newDate);
    //       dispatch(updateSelectedDate(newDate))
    //     fetchOrders(newDate);
    //   };

    useEffect(() => {
        if (selectedDate) {
            if (selectedDate instanceof Date) {
                // Single day selected
                dispatch(updateSelectedDate(selectedDate))
                fetchOrders(selectedDate, selectedDate);
            } else if (Array.isArray(selectedDate) && selectedDate[0] && selectedDate[1]) {
                // Range selected
                dispatch(updateSelectedDate(selectedDate))
                fetchOrders(selectedDate[0], selectedDate[1]);
            }
        }
    }, [selectedDate]);


    const viewAllOrders = () => {
        // dispatch(updatefilteredOrders(orders)); 
        fetchOrdersBasedOnHub()
    };

    const handleDownloadGstReport = async () => {
        let startDate;
        let endDate;

        if (selectedDate instanceof Date) {
            startDate = dayjs(selectedDate).format('YYYY-MM-DD');
            endDate = startDate;
        } else if (Array.isArray(selectedDate) && selectedDate[0]) {
            startDate = dayjs(selectedDate[0]).format('YYYY-MM-DD');
            endDate = selectedDate[1]
                ? dayjs(selectedDate[1]).format('YYYY-MM-DD')
                : startDate;
        } else {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please select a date or range', life: 2000 });
            return;
        }

        try {
            setGstDownloading(true);
            const response = await CustomAxios.get(
                `reports/gst/?start_date=${startDate}&end_date=${endDate}`,
                { responseType: 'blob' }
            );

            const contentType = response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            const blob = new Blob([response.data], { type: contentType });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            const contentDisposition = response.headers['content-disposition'];
            let filename = `gst_report_${startDate}_to_${endDate}.xlsx`;

            if (contentDisposition && contentDisposition.includes('filename=')) {
                filename = contentDisposition.split('filename=')[1].replace(/"/g, '').trim();
            }

            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('GST report download failed', error);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to download GST report', life: 2000 });
        } finally {
            setGstDownloading(false);
        }
    };

    useEffect(() => {
        if (orders.length === 0) {
            dispatch(updatefilteredOrders([]));
        }
    }, [orders]);

    const [pending, Setpending] = useState(0)
    const [assigned, SetAssigned] = useState(0)
    const [completed, SetCompleted] = useState(0)
    useEffect(() => {
        if (filteredOrders.length > 0) {
            const pendingOrders = filteredOrders.filter((item) => item.status === "pending")
            const assignedOrders = filteredOrders.filter((item) => item.status === "delivery_partner_assigned")
            const completedOrders = filteredOrders.filter((item) => item.status === "delivered" || item.status === "picked")
            Setpending(pendingOrders.length)
            SetAssigned(assignedOrders.length)
            SetCompleted(completedOrders.length)
        } else {
            Setpending(0)
            SetAssigned(0)
            SetCompleted(0)
        }
    }, [filteredOrders])

    const fetchOrdersBasedOnHub = async () => {
        const selectedHubRaw = localStorage.getItem('selected_hub')
        const userRole = localStorage.getItem('role');
        
        // Cashiers should never trigger the full inventory fetch.
        if (userRole === 'cashier') {
            return;
        }
        
        try {
            dispatch(updateLoading(true))
            dispatch(updateOrders([]));

            let response;
            let ordersData;

            if (userRole === 'super_admin') {
                // Super admin uses getAllOrders endpoint to get all orders
                response = await CustomAxios.get(`get_all_orders/`);
                ordersData = {
                    current_orders: response.data.filter(order => 
                        !['delivered', 'cancelled', 'declined', 'picked'].includes(order.status) && order.payment_status === true
                    ),
                    history_orders: response.data.filter(order => 
                        ['delivered', 'cancelled', 'declined', 'picked'].includes(order.status) && order.payment_status === true
                    ),
                    response: true
                };
            } else {
                // Other roles use inventory-specific endpoint
                let selectedHub;
                try {
                    const parsedHub = JSON.parse(selectedHubRaw || '[]');
                    if (Array.isArray(parsedHub) && parsedHub.length > 0) {
                        selectedHub = parsedHub[0];
                    } else {
                        selectedHub = parsedHub;
                    }
                } catch (error) {
                    selectedHub = selectedHubRaw;
                }

                if (userRole === 'cashier' && selectedDate && selectedDate[0]) {
                const start = dayjs(selectedDate[0]).format('DD-MM-YYYY');
                const end = selectedDate[1] ? dayjs(selectedDate[1]).format('DD-MM-YYYY') : start;
                response = await CustomAxios.get(`get_orders_date/${selectedHub}/?start=${start}&end=${end}&time=11:00`);
                ordersData = {
                    response: true,
                    current_orders: response.data || [],
                    history_orders: []
                };
                } else {
                response = await CustomAxios.get(`get_all_orders_inventory/${selectedHub}/`);
                ordersData = response.data;
                }
            }

            // console.log("order data ------------", ordersData, ordersData.response === true && ordersData.current_orders?.length > 0);

            if (ordersData.response === true) {
                dispatch(updateFoodfixCutoffTime(ordersData.foodfix_cutoff_time || null));
                // setisOrderd(true);
                dispatch(updateOrders([...ordersData.current_orders, ...ordersData.history_orders]));
                dispatch(updatefilteredOrders([...ordersData.current_orders, ...ordersData.history_orders]));
                
                // Check if this is a FoodFix franchise (franchise_id = 2)
                if (ordersData.franchise_id === 2) {
                    console.log('🍽️ OrderManagement: API returned FoodFix franchise, showing stall filter');
                    dispatch(updateShowStallFilter(true));
                    fetchStallsForFranchise(2);
                } else {
                    console.log('🍽️ OrderManagement: API returned non-FoodFix franchise, hiding stall filter');
                    dispatch(updateShowStallFilter(false));
                    setStalls([]);
                    dispatch(updateSelectedStalls([]));
                    dispatch(updateSelectedCategories([]));
                    dispatch(updateFoodfixCutoffTime(null));
                }
            } else {
                // setisOrderd(false);
                dispatch(updateOrders([]));
                dispatch(updatefilteredOrders([]));
                dispatch(updateShowStallFilter(false));
                setStalls([]);
                dispatch(updateSelectedStalls([]));
                dispatch(updateFoodfixCutoffTime(null));
            }
            dispatch(updateLoading(false))
        } catch (err) {
            console.error("Error fetching orders", err);
            //   setisOrderd(false);
            dispatch(updateLoading(false))
            dispatch(updateOrders([]));
            dispatch(updatefilteredOrders([]));
            dispatch(updateFoodfixCutoffTime(null));
        }
    };
    useEffect(()=>{
        if(partners.length > 0){
            const filteredPartners = partners.filter(partner => {
                return partner.inventory_Id === JSON.parse(localStorage.getItem("selected_hub"))
            })
            setDeliveryPartners(filteredPartners)
        }
    }, [partners])
    // Check if user can manage orders - AFTER all hooks
    if (!canManageOrders) {
        return (
            <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: "12px", md: "20px" }, padding: { xs: "12px", sm: "20px" } }}>
                <Typography variant="h6" color="error" sx={{ fontSize: { xs: "16px", sm: "20px" } }}>
                    Access Denied
                </Typography>
                <Typography sx={{ fontSize: { xs: "12px", sm: "14px" } }}>
                    You don't have permission to manage orders. You can only send push notifications.
                </Typography>
            </Box>
        );
    }

    // For cashiers, show create order component and walk-in order list
    if (isCashier) {
        return (
            <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: "12px", md: "20px" }, width: "100%", padding: { xs: "12px", sm: "20px", md: "30px" } }}>
                <Toast ref={toast} />
                <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" transition="Bounce" />
                <Typography sx={{ fontSize: { xs: "14px", sm: "16px" }, fontWeight: "700", lineHeight: "24px", marginBottom: "16px" }}>Create Order</Typography>
                <Box sx={{ marginBottom: "24px" }}>
                    <KioskOrderManagement />
                </Box>
                <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: { xs: "8px", md: "16px" }, alignItems: { xs: "flex-start", md: "center" } }}>
                    <Typography sx={{ fontSize: { xs: "14px", sm: "16px" }, fontWeight: "700", lineHeight: "24px" }}>Walk-in Orders</Typography>
                    <Box sx={{ display: "flex", gap: { xs: "8px", md: "16px" }, alignItems: "center", width: { xs: "100%", md: "auto" } }}>
                        {Array.isArray(selectedDate) &&
                            selectedDate[0] &&
                            dayjs(selectedDate[0]).format('DD-MM-YYYY') === dayjs().format('DD-MM-YYYY') && (
                                <Typography
                                    sx={{
                                        fontSize: { xs: "12px", sm: "16px" },
                                        fontWeight: "500",
                                        lineHeight: "24px",
                                    }}
                                >
                                    Today
                                </Typography>
                            )}
                    <Box sx={{ display: "flex", flexDirection: "column", width: { xs: "100%", sm: "auto" } }}>
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ width: { xs: "100%", sm: "auto" }, maxWidth: { xs: "100%", sm: "300px" } }}>
                            <Calendar value={selectedDate}
                                onChange={(e) => setSelectedDate(e.value)}
                                selectionMode="range"
                                readOnlyInput
                                hideOnRangeSelection
                                placeholder="Select Date or Range"
                                showIcon
                                dateFormat="dd-mm-yy"
                                style={{ width: '100%' }} />
                        </Stack>
                        {isFoodfix && (
                                <Typography sx={{ fontSize: { xs: "11px", sm: "12px" }, color: "#00B3A4", fontWeight: "600", marginTop: "8px" }}>
                                    Orders from {orderFetchStartTime}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                </Box>
                <Typography sx={{ fontSize: { xs: "12px", sm: "13px" }, fontWeight: "500", lineHeight: "20px", color: "text.secondary" }}>
                    Showing walk-in orders for {Array.isArray(selectedDate) && selectedDate[0] ? dayjs(selectedDate[0]).format('DD MMM YYYY') : 'selected date'}
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: "8px", md: "12px" } }}>
                    {ordersLoading ? (
                        <Box sx={{ backgroundColor: "#fff", borderRadius: "8px", padding: "20px", display: "flex", flexDirection: "column", gap: "12px" }}>
                            {[1, 2, 3].map((row) => (
                                <Box key={row} sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                    <Skeleton variant="rounded" animation="wave" sx={{ height: "40px", background: "rgb(0 0 0 / 6%)" }} />
                                    <Skeleton variant="rounded" animation="wave" sx={{ height: "40px", background: "rgb(0 0 0 / 6%)" }} />
                                </Box>
                            ))}
                        </Box>
                    ) : filteredOrders.length > 0 ? (
                        <OrderListTable />
                    ) : (
                        <Typography sx={{ fontSize: { xs: "12px", sm: "14px" }, color: "text.secondary", padding: "20px", textAlign: "center" }}>
                            No walk-in orders found
                        </Typography>
                    )}
                </Box>
                <OrderModal />
                <OrderModalDelivery />
            </Box>
        );
    }
    
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: "12px", md: "20px" }, width: "100%", padding: { xs: "12px", sm: "20px", md: "30px" } }}>
            <Toast ref={toast} />
            <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" transition="Bounce" />
            <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: "8px", md: "8px" } }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", gap: { xs: "8px", md: "0px" }, flexDirection: { xs: "column", md: "row" }, alignItems: { xs: "flex-start", md: "center" } }}>
                    <Typography sx={{ fontSize: { xs: "14px", sm: "16px" }, fontWeight: "700", lineHeight: "24px" }}>Order Management</Typography>
                    <Box sx={{ display: "flex", gap: { xs: "8px", md: "20px" }, alignItems: "center", flexDirection: { xs: "column", sm: "row" }, width: { xs: "100%", md: "auto" } }}>
                        {Array.isArray(selectedDate) &&
                            selectedDate[0] &&
                            dayjs(selectedDate[0]).format('DD-MM-YYYY') === dayjs().format('DD-MM-YYYY') && (
                                <Typography
                                    sx={{
                                        fontSize: { xs: "12px", sm: "16px" },
                                        fontWeight: "500",
                                        lineHeight: "24px",
                                        textAlign: "center",
                                        marginBottom: "22px"
                                    }}
                                >
                                    Today
                                </Typography>
                            )}
                    <Box sx={{ display: "flex", flexDirection: "column", width: { xs: "100%", sm: "auto" } }}>
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ width: { xs: "100%", sm: "auto" }, maxWidth: { xs: "100%", sm: "300px" } }}>
                            <Calendar value={selectedDate}
                                onChange={(e) => setSelectedDate(e.value)}
                                selectionMode="range"
                                readOnlyInput
                                hideOnRangeSelection
                                placeholder="Select Date or Range"
                                showIcon
                                dateFormat="dd-mm-yy"
                                style={{ width: '100%' }} />
                        </Stack>
                        {isFoodfix && (
                                <Typography sx={{ fontSize: { xs: "11px", sm: "12px" }, color: "#00B3A4", fontWeight: "600", marginTop: "8px" }}>
                                    Orders from {orderFetchStartTime}
                                </Typography>
                            )}
                        </Box>
                    </Box>

                </Box>
                <Box sx={{ display: "flex", gap: { xs: "8px", sm: "12px", md: "20px" }, marginBottom: { xs: "16px", md: "30px" }, flexWrap: { xs: "wrap", sm: "nowrap" }, justifyContent: { xs: "center", sm: "flex-start" } }}>
                    <Box sx={{ height: { xs: "80px", md: "100px" }, maxWidth: { xs: "calc(50% - 4px)", sm: "172px" }, width: { xs: "calc(50% - 4px)", sm: "100%" }, backgroundColor: "#FDE9F2", borderRadius: "8px", boxShadow: "10px 10px 15px 0px #ED1E7933", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", border: "1px solid #F8A5C9" }}>
                        <Typography sx={{ fontSize: { xs: "18px", sm: "24px" }, fontWeight: "500", lineHeight: "32px" }}>  {Array.isArray(filteredOrders) ? filteredOrders.length : 0}
                        </Typography>
                        <Typography sx={{ fontSize: { xs: "10px", sm: "12px", md: "14px" }, fontWeight: "400", lineHeight: "22px" }}>Total Orders</Typography>
                    </Box>
                    <Box sx={{ height: { xs: "80px", md: "100px" }, maxWidth: { xs: "calc(50% - 4px)", sm: "172px" }, width: { xs: "calc(50% - 4px)", sm: "100%" }, backgroundColor: "#E6F1F8", borderRadius: "8px", boxShadow: "10px 10px 15px 0px #0071BC33", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", border: "1px solid #80B8DE" }}>
                        <Typography sx={{ fontSize: { xs: "18px", sm: "24px" }, fontWeight: "500", lineHeight: "32px" }}>{pending}</Typography>
                        <Typography sx={{ fontSize: { xs: "10px", sm: "12px", md: "14px" }, fontWeight: "400", lineHeight: "22px", textAlign: "center" }}>New Orders</Typography>
                    </Box>
                    <Box sx={{ height: { xs: "80px", md: "100px" }, maxWidth: { xs: "calc(50% - 4px)", sm: "172px" }, width: { xs: "calc(50% - 4px)", sm: "100%" }, backgroundColor: "#FFF7EB", borderRadius: "8px", boxShadow: "10px 10px 15px 0px #FBB03B33", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", border: "1px solid #FDD089" }}>
                        <Typography sx={{ fontSize: { xs: "18px", sm: "24px" }, fontWeight: "500", lineHeight: "32px" }}>{assigned}</Typography>
                        <Typography sx={{ fontSize: { xs: "10px", sm: "12px", md: "14px" }, fontWeight: "400", lineHeight: "22px", textAlign: "center" }}>Orders in Progress</Typography>
                    </Box>
                    <Box sx={{ height: { xs: "80px", md: "100px" }, maxWidth: { xs: "calc(50% - 4px)", sm: "172px" }, width: { xs: "calc(50% - 4px)", sm: "100%" }, backgroundColor: "#F0FDF4", borderRadius: "8px", boxShadow: "10px 10px 15px 0px #4ADE8033", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", border: "1px solid #86EFAC" }}>
                        <Typography sx={{ fontSize: { xs: "18px", sm: "24px" }, fontWeight: "500", lineHeight: "32px" }}>{completed}</Typography>
                        <Typography sx={{ fontSize: { xs: "10px", sm: "12px", md: "14px" }, fontWeight: "400", lineHeight: "22px", textAlign: "center" }}>Completed Orders</Typography>
                    </Box>
                </Box>
                <Typography sx={{ fontSize: { xs: "12px", sm: "14px" }, fontWeight: "500", lineHeight: "22px" }}>Order Lists</Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", flexDirection: { xs: "column", sm: "row" }, gap: { xs: "12px", sm: "0px" } }}>
                <Box sx={{ display: "flex", gap: { xs: "8px", sm: "12px" }, width: { xs: "100%", sm: "auto" }, alignItems: "center" }}>
                    <Box sx={{ position: "relative", width: { xs: "100%", sm: "auto" }, flex: { xs: "1", sm: "0 0 auto" } }}>
                        <InputBase sx={{ backgroundColor: "white", height: { xs: "36px", md: "32px" }, width: "100%", maxWidth: { xs: "100%", sm: "268px" }, borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px 5px 40px", fontSize: { xs: "12px", sm: "14px" }, fontWeight: "400", lineHeight: "22px", color: "black" }} onChange={(e) =>
                            dispatch(updateSearchOrders(e.target.value))} placeholder="Search order Id" />
                        <SearchIcon sx={{ position: "absolute", left: "12px", top: { xs: "8px", md: "5px" }, width: { xs: "18px", md: "20px" }, height: { xs: "18px", md: "20px" } }} />
                    </Box>
                    <Box sx={{ 
                        minWidth: { xs: "100%", sm: "180px" }, 
                        maxWidth: { xs: "100%", sm: "200px" },
                        '& .p-dropdown': {
                            height: { xs: "36px", md: "32px" },
                            fontSize: { xs: "12px", sm: "14px" },
                            width: '100%'
                        },
                        '& .p-dropdown-label': {
                            textAlign: 'center',
                            padding: { xs: "5px 12px", sm: "6px 14px" }
                        }
                    }}>
                        <Dropdown
                            value={selectedSlotType}
                            onChange={(e) => {
                                const newType = e.value;
                                dispatch(updateSelectedSlotType(newType));
                                // Clear time selection when a specific type is selected to avoid invalid combinations
                                // (time slots will update based on the new type)
                                if (newType) {
                                    dispatch(updateSelectedSlotTime(null));
                                }
                            }}
                            options={slotTypes}
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Slot Type"
                            style={{ zIndex: "1000" }}
                            className="w-full"
                        />
                    </Box>
                    <Box sx={{ 
                        minWidth: { xs: "100%", sm: "180px" }, 
                        maxWidth: { xs: "100%", sm: "200px" },
                        '& .p-dropdown': {
                            height: { xs: "36px", md: "32px" },
                            fontSize: { xs: "12px", sm: "14px" },
                            width: '100%'
                        },
                        '& .p-dropdown-label': {
                            textAlign: 'center',
                            padding: { xs: "5px 12px", sm: "6px 14px" }
                        }
                    }}>
                        <Dropdown
                            value={selectedSlotTime}
                            onChange={(e) => dispatch(updateSelectedSlotTime(e.value))}
                            options={slotTimes}
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Slot Time"
                            style={{ zIndex: "1000" }}
                            className="w-full"
                        />
                    </Box>
                </Box>
                <Box sx={{ display:"flex",alignItems:"center",justifyContent:{ xs: "flex-start", sm: "center" },gap:{ xs: "8px", sm: "10px" }, flexWrap: "wrap" }}>
                    {!isFoodfix && (
                        <Button variant="contained" sx={{ textTransform: "none", fontSize: { xs: "12px", sm: "14px" }, padding: { xs: "6px 12px", sm: "8px 16px" } }} onClick={() => {
                            dispatch(updateKioskProduct([]));
                            navigate('/home/kiosk_order');
                        }}>create order</Button>
                    )}
                    <Button
                        variant="contained"
                        startIcon={<DownloadIcon sx={{ fontSize: { xs: "16px", sm: "20px" } }} />}
                        disabled={gstDownloading}
                        sx={{
                            backgroundColor: "#1976d2",
                            textTransform: "none",
                            fontSize: { xs: "12px", sm: "14px" },
                            padding: { xs: "6px 12px", sm: "8px 16px" },
                            "&:hover": {
                                backgroundColor: "#1565c0"
                            }
                        }}
                        onClick={handleDownloadGstReport}
                    >
                        {gstDownloading ? "Downloading..." : "Download GST Report"}
                    </Button>
                    <Button variant="contained" sx={{ textTransform: "none", fontSize: { xs: "12px", sm: "14px" }, padding: { xs: "6px 12px", sm: "8px 16px" } }} onClick={() => viewAllOrders()}>View all</Button>
                </Box>
            </Box>

            {/* Stall Filtering for FoodFix (Franchise 2) */}
            {showStallFilter && (
                <Box sx={{ display: "flex", gap: { xs: "8px", md: "10px" }, backgroundColor: "#f8f9fa", padding: { xs: "12px", md: "15px" }, borderRadius: "8px", border: "1px solid #e9ecef", justifyContent: { xs: "flex-start", md: "space-between" }, alignItems: { xs: "flex-start", md: "flex-end" }, flexDirection: { xs: "column", md: "row" } }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: "10px", md: "15px" }, flexWrap: "wrap", width: { xs: "100%", md: "auto" } }}>
                    <Typography sx={{ fontSize: { xs: "12px", sm: "14px" }, fontWeight: "600", lineHeight: "22px", color: "#00B3A4" }}>
                        🍽️ FoodFix Stall Filtering
                    </Typography>
                    <Box sx={{ display: "flex", gap: { xs: "8px", md: "15px" }, alignItems: { xs: "flex-start", md: "center" }, flexWrap: "wrap", flexDirection: { xs: "column", sm: "row" }, width: { xs: "100%", md: "auto" } }}>
                        <Box sx={{ minWidth: { xs: "100%", sm: "300px" }, width: { xs: "100%", sm: "auto" } }}>
                            <MultiSelect
                                value={selectedStalls}
                                onChange={(e) => {
                                    console.log('🍽️ Stall selection changed:', e.value);
                                    dispatch(updateSelectedStalls(e.value));
                                }}
                                options={stalls}
                                optionValue="id"
                                optionLabel="stall_name"
                                name="stall_filter"
                                placeholder="Select Stalls to Filter Orders"
                                className="w-full"
                                checkmark={true}
                                highlightOnSelect={false}
                                style={{ width: '100%' }}
                            />
                        </Box>
                        {(() => {
                            const filteredForCounts = filterOrdersByStalls(orderList);
                            const pendingCount = filteredForCounts.filter(o => o.status === 'pending').length;
                            const outForDeliveryCount = filteredForCounts.filter(o => o.status === 'accepted' ).length;
                            const deliverableCount = filteredForCounts.filter(o => o.status === 'ready_for_pickup' || o.status === 'delivery_partner_assigned').length;

                            return (
                                <BulkActionsDropdown
                                    loading={loading}
                                    disabled={selectedStalls.length === 0}
                                    counts={{ pendingCount, outForDeliveryCount, deliverableCount }}
                                    onAccept={handleBulkAcceptOrders}
                                    onOutForDelivery={handleBulkOutForDeliveryOrders}
                                    onDelivered={handleBulkDeliveredOrders}
                                />
                            );
                        })()}
                        <Button 
                            variant="outlined" 
                            sx={{ 
                                textTransform: "none",
                                borderColor: "#00B3A4",
                                color: "#00B3A4",
                                fontSize: { xs: "12px", sm: "14px" },
                                padding: { xs: "6px 12px", sm: "8px 16px" }
                            }}
                            onClick={() => {
                                dispatch(updateSelectedStalls([]));
                                dispatch(updateSelectedCategories([]));
                            }}
                        >
                            Clear Filter
                        </Button>
                        <Box sx={{ minWidth: { xs: "100%", sm: "300px" }, width: { xs: "100%", sm: "auto" } }}>
                            <MultiSelect
                                value={selectedCategories}
                                onChange={(e) => {
                                    console.log('🍽️ Category selection changed:', e.value);
                                    dispatch(updateSelectedCategories(e.value));
                                }}
                                options={categories}
                                optionValue="id"
                                optionLabel="category_name"
                                name="category_filter"
                                placeholder="Select Category"
                                className="w-full"
                                checkmark={true}
                                highlightOnSelect={false}
                                style={{ width: '100%' }}
                            />
                        </Box>
                    </Box>
                    {selectedStalls.length > 0 && (
                        <Typography sx={{ fontSize: { xs: "10px", sm: "12px" }, color: "#6c757d", fontStyle: "italic" }}>
                            Showing orders for {selectedStalls.length} selected stall(s): {selectedStalls.map(s => s.stall_name).join(", ")}
                        </Typography>
                    )}
                    </Box>    
                        <Button
                        variant="contained"
                        disabled = { loading || selectedStalls.length === 0 || orderList.length === 0 || filterOrdersByStalls(orderList).some(o => o.status == 'accepted' || o.status == 'pending') || (filterOrdersByStalls(orderList).length > 0 && filterOrdersByStalls(orderList).every(o => o.status == 'delivered'))}
                        sx={{
                            textTransform: "none",
                            backgroundColor: "#00B3A4",
                            height: { xs: "32px", md: "36px" },
                            fontSize: { xs: "12px", sm: "14px" },
                            padding: { xs: "6px 12px", sm: "8px 16px" },
                            width: { xs: "100%", md: "auto" },
                            '&:hover': { backgroundColor: "#00a396" }
                        }}
                            onClick={() => {
                                if (filteredOrders.length > 0) {
                                    dispatch(updatePartnerAssignModal(true));
                                } else {
                                    toast.current?.show({ severity: 'warn', summary: 'Select Order', detail: 'Select an order to assign a delivery partner', life: 2000 });
                                }
                            }}
                        >
                            Assign Delivery Partner
                        </Button>
                </Box>
            )}
            <OrderListTable />
            <OrderModal />
            <OrderModalDelivery />

        </Box>
    )
}